import axios from 'axios';

// Repricing Amazon / eBay (features/repricing): il prezzo insegue Buy Box o concorrente fra minimo e massimo.

const buildUrl = (context, path) => `${context.rootGetters['settings/getUrl']}repricing/${path}`;

const authHeader = context => ({ Authorization: `Bearer ${context.rootGetters['profile/getToken']}` });

const fail = err => {
	const detail = err?.response?.data?.error;
	return {
		error: Array.isArray(detail) ? detail.map(e => (typeof e === 'string' ? e : e.msg || e.param)).join(', ') : detail || err?.response?.status || true,
		status: err?.response?.status,
	};
};

const request = promise => promise.then(res => res.data).catch(fail);

const actions = {
	// regole, interruttore ed esito dell'ultimo giro
	overview: (context, { platform }) => request(axios.get(buildUrl(context, platform), { headers: authHeader(context) })),

	getRule: (context, { id }) => request(axios.get(buildUrl(context, `rule/${id}`), { headers: authHeader(context) })),

	saveRule: (context, { platform, rule }) =>
		request(
			rule._id ? axios.put(buildUrl(context, `rule/${rule._id}`), rule, { headers: authHeader(context) }) : axios.post(buildUrl(context, `${platform}/rules`), rule, { headers: authHeader(context) }),
		),

	toggleRule: (context, { id, active }) => request(axios.patch(buildUrl(context, `rule/${id}/active`), { active }, { headers: authHeader(context) })),

	moveRule: (context, { id, direction }) => request(axios.post(buildUrl(context, `rule/${id}/move`), { direction }, { headers: authHeader(context) })),

	duplicateRule: (context, { id }) => request(axios.post(buildUrl(context, `rule/${id}/duplicate`), {}, { headers: authHeader(context) })),

	removeRule: (context, { id }) => request(axios.delete(buildUrl(context, `rule/${id}`), { headers: authHeader(context) })),

	// con i dati dell'ultima analisi, senza chiamare i marketplace
	preview: (context, { platform, rule }) => request(axios.post(buildUrl(context, `${platform}/preview`), { rule }, { headers: authHeader(context) })),

	setEnabled: (context, { platform, enabled }) => request(axios.put(buildUrl(context, `${platform}/enabled`), { enabled }, { headers: authHeader(context) })),

	run: (context, { platform }) => request(axios.post(buildUrl(context, `${platform}/run`), {}, { headers: authHeader(context) })),

	products: (context, { platform, ...params }) => request(axios.get(buildUrl(context, `${platform}/products`), { headers: authHeader(context), params })),

	setOverride: (context, { platform, id, override }) => request(axios.put(buildUrl(context, `${platform}/products/${id}/override`), override, { headers: authHeader(context) })),

	logs: (context, { platform, ...params }) => request(axios.get(buildUrl(context, `${platform}/logs`), { headers: authHeader(context), params })),
};

export default {
	namespaced: true,
	actions,
};
